module.exports = __webpack_public_path__ + "static/media/airbtics_pro_ca_cover.2523aab5.jpg";